import styled from 'styled-components';
import preloaderImg from '../../../svg/dot-preloader-dark.svg';

export const Title = styled.b`
  display: flex;
  justify-content: space-between;
  padding: 8px 20px;
  text-align: center;
  background: #d6d5d5;
`;

export const SubTitle = styled.span`
  display: block;
  margin-left: 10px;
  color: #434343;
`;

export const Screenshots = styled.div`
  display: flex;
  flex-wrap: wrap;
  span {
    display: block;
    text-align: center;
    color: #999;
    display: block;
    padding: 5px;
    width: 100%;
  }
`;

export const STable = styled.table`
  border: 1px solid #ccc;
  border-collapse: collapse;
  margin: 0;
  margin-bottom: 10px;
  padding: 0;
  width: 100%;
  table-layout: fixed;

  caption {
    font-size: 1.5em;
    margin: 0.5em 0 0.75em;
  }

  tr {
    background-color: #f8f8f8;
    border: 1px solid #ddd;
    padding: 0.35em;
  }

  th,
  td {
    padding: 0.625em;
    text-align: center;
  }

  th {
    font-size: 0.85em;
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }

  @media screen and (max-width: 600px) {
    border: 0;

    caption {
      font-size: 1.3em;
    }

    thead {
      border: none;
      clip: rect(0 0 0 0);
      height: 1px;
      margin: -1px;
      overflow: hidden;
      padding: 0;
      position: absolute;
      width: 1px;
    }

    tr {
      border-bottom: 3px solid #ddd;
      display: block;
      margin-bottom: 0.625em;
    }

    td {
      border-bottom: 1px solid #ddd;
      display: block;
      font-size: 0.8em;
      text-align: right;
    }

    td::before {
      content: attr(data-label);
      float: left;
      font-weight: bold;
      text-transform: uppercase;
    }

    td:last-child {
      border-bottom: 0;
    }
  }
`;

export const NoTasks = styled.div`
  color: #999;
  padding: 30px 5px;
  text-align: center;
`;

export const Day = styled.div`
  text-align: center;
  padding: 10px;
  color: #999;
`;

export const BoardWrapper = styled.div`
  position: relative;
`;

export const BoardPreloader = styled.div`
  width: 100%;
  background-image: url(${preloaderImg});
  position: absolute;
  background-position: center center;
  background-repeat: no-repeat;
  height: 300px;
  top: 0;
  left: 0;
  background-size: 40px;
`;

export const ScreenInner = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  span {
    display: block;
    transition: 0.3s ease-in-out;
    cursor: pointer;
    &:hover {
      color: #0093dd;
    }
  }
`;
